import React from "react";

import api from "../api";

const useAPI = () => api;

export default useAPI;
